
import { PaginatedResponse, SubTechnology } from '@/api/interfaces';
import axios, { AxiosPromise } from 'axios';

import { Query } from '../query';

const resources = {
  default: 'connectivity/sub-technologies',
};
type subTechnologyCreateData = {
  name: string;
  slug: string;
};

interface SubTechnologyApiInterface {
  getSubTechnologies: (
    query?: Query,
  ) => AxiosPromise<PaginatedResponse<SubTechnology>>;
  create: (data: subTechnologyCreateData) => AxiosPromise<SubTechnology>;
  update: (
    slug: string,
    data: subTechnologyCreateData,
  ) => AxiosPromise<SubTechnology>;
  delete: (slug: string) => AxiosPromise<void>;
}

const subTechnologyApi: SubTechnologyApiInterface = {
  getSubTechnologies(query = new Query()) {
    return axios.get(`${resources.default}/${query}`);
  },
  create(data: subTechnologyCreateData) {
    return axios.post(`${resources.default}/`, data);
  },
  update(slug, data: subTechnologyCreateData) {
    return axios.patch(`${resources.default}/${slug}/`, data);
  },
  delete(slug) {
    return axios.delete(`${resources.default}/${slug}/`);
  },
};

export default subTechnologyApi;

export { SubTechnologyApiInterface, subTechnologyCreateData };
